/**
 * Creates a timeout signal that aborts after the specified duration.
 * @returns {AbortSignal}
 */
export const createTimeoutSignal = (duration = 60) => {
	const controller = new AbortController();

	setTimeout(() => {
		controller.abort();
	}, duration * 1000);

	return controller.signal;
};

/**
 * Scrolls to the first invalid field ()`.input--error`) in the form.
 */
export const scrollToInvalidField = () => {
	const fieldEl = document.querySelector('.input--error');

	if (!fieldEl) {
		return;
	}

	fieldEl.scrollIntoView({
		behavior: 'smooth',
		block: 'center',
	});
};
